import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom"
// import datas from '../../json/Careerpage/Careerpage.json'
import datas from '../../json/Careerpage/CareerpageNew.json'
import { sentCareer } from "../../api/api";
import toast from "react-hot-toast";
import ReactDOMServer from 'react-dom/server';
import EmailTemplate from "../EmailTemplate";

const CareerDetail = ({ data }) => {
    const [dropdownOpen, setDropdownOpen] = useState({})
    const location = useLocation()
    const path = location.pathname.split("/")[3];
    const matched = datas.openings.filter((item) => item.url == path)
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        file: "",
        experience: "",
        position: "",
        notice: ""
    })
    const fileInputRef = useRef(null);
    const divRefs = useRef([]);
    const submittingRef = useRef(false);

    // Reset refs on every render to avoid stale refs
    divRefs.current = [];

    const setDivRef = (el) => {
        if (el && !divRefs.current.includes(el)) {
            divRefs.current.push(el);
        }
    };


    const validateForm = (data) => {
        const errors = {};

        // Validate Name
        if (!data.name.trim()) {
            errors.name = "Name is required.";
        }

        // Validate Email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!data.email.trim()) {
            errors.email = "Email is required.";
        } else if (!emailRegex.test(data.email)) {
            errors.email = "Invalid email format.";
        }

        // Validate Phone
        const phoneRegex = /^[0-9]{10}$/;  // Adjust regex as needed
        if (!data.phone.trim()) {
            errors.phone = "Phone number is required.";
        } else if (!phoneRegex.test(data.phone)) {
            errors.phone = "Phone number must be 10 digits.";
        }

        // Validate File
        if (!data.file) {
            errors.file = "File is required.";
        }

        // Validate Experience
        if (!data.experience.trim()) {
            errors.experience = "Experience is required.";
        }

        // Validate Position
        if (!data.position.trim()) {
            errors.position = "Position is required.";
        }

        // Validate Notice Period
        if (!data.notice.trim()) {
            errors.notice = "Notice period is required.";
        }

        return errors;
    };


    const handleClick = (e) => {
        e.preventDefault()
        fileInputRef.current.click();

    };

    const toggleDropdown = (index) => {
        setDropdownOpen((prev) => ({
            [index]: !prev[index],
        }));
    };

    const handleFiles = (files) => {
        setFormData((prev) => ({
            ...prev,
            file: files[0],
        }))

    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone") {
            const numbersOnly = value.replace(/\D/g, "");
            const trimmed = numbersOnly.slice(0, 10);
            setFormData((prev) => ({
                ...prev,
                [name]: trimmed,
            }))
            return;
        }


        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }))
    };

    const handleSelectChange = (e) => {
        const name = e.currentTarget.dataset.name; // Get the name from data attribute
        const value = e.currentTarget.textContent;

        setFormData((prev) => ({
            ...prev,
            [name]: value
        }))
        setDropdownOpen({})
    }


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (submittingRef.current) return; //  Prevent double click instantly
        submittingRef.current = true;// Disable the button
        document.body.style.cursor = "wait";
        const validationErrors = validateForm(formData);
        setErrors(validationErrors);


        if (Object.keys(validationErrors).length === 0) {
            console.log("Form data is valid:", formData);
            const formDataToSend = new FormData();
            const htmlString = ReactDOMServer.renderToStaticMarkup(
                <EmailTemplate data={formData} page="career" />
            );

            formDataToSend.append(
                "subject",
                `Mail from ${formData.name} `,
            );
            formDataToSend.append('html', htmlString);

            formDataToSend.append("resume", formData.file);

            try {
                const response = await sentCareer(formDataToSend);

                if (response.data) {

                    setErrors({})
                    setDropdownOpen({})
                    setFormData({
                        name: "",
                        email: "",
                        phone: "",
                        file: "",
                        experience: "",
                        position: "",
                        notice: ""
                    })
                    toast.success("Application Submit successfull!");
                } else {
                    toast(
                        response.error.message + ", Message could not be sent" ||
                        "Failed to send message"
                    );
                }
            } catch (err) {
                toast("An unexpected error occurred");
            }
            finally {
                document.body.style.cursor = "default";
                submittingRef.current = false;
            }
            // Proceed with form submission (e.g., API call or NodeMailer)
        } else {
            toast("Please fill All fields");
            document.body.style.cursor = "default";
            submittingRef.current = false;

        }
    };
    const handleCancel = () => {
        setErrors({})
        setDropdownOpen({})
        setFormData({
            name: "",
            email: "",
            phone: "",
            file: "",
            experience: "",
            position: "",
            notice: ""
        })
    }

    useEffect(() => {
        if (matched?.[0]?.url == path) {
            setFormData((prev) => ({
                ...prev,
                position: matched[0].title
            }))

        }

    }, [])



    useEffect(() => {
        function handleClickOutside(event) {
            const clickedInsideAny = divRefs.current.some((ref) =>
                ref.contains(event.target)
            );

            if (!clickedInsideAny) {
                setDropdownOpen({}); // Clicked outside all divs
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="w-full flex justify-center relative">
            <div className="business absolute  top- -z-[1] w-full h-[60vh]">
            </div>
            <div className="2xl:container w-full md:px-10 lg:px-20  px-6 flex flex-col-reverse lg:flex-row gap-10 my-12 sm:my-16 md:my-20 justify-center lg:justify-start">
                <div className="lg:w-[70%] w-full border-[1px] border-journyborder rounded-[24px] shadow-services p-6 md:p-8 bg-white">
                    <h2 className="w-full text-24 text-primarycolor text-center font-semibold">Applicant Details</h2>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div>
                            <p className="text-18 font-semibold text-primarycolor py-6">Personal Details*</p>
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-6">
                                <div>
                                    <input

                                        type="text"
                                        onChange={(e) => handleChange(e)}
                                        name="name"
                                        value={formData.name}
                                        placeholder="Name*"
                                        required // Conditionally add the required attribute
                                        className={` w-full placeholder:text-secondaryblack border border-journeyborder rounded-[12px]  px-4 py-[12px]  text-16 md:text-18  md:mb-0 outline-none`}
                                    />
                                    {errors.name && <p className="text-red-500 mt-2">*{errors.name}</p>}
                                </div>
                                <div>
                                    <input
                                        type="email"
                                        onChange={(e) => handleChange(e)}
                                        value={formData.email}
                                        name="email"
                                        placeholder="Email*"
                                        required // Conditionally add the required attribute
                                        className={` w-full outline-none placeholder:text-secondaryblack border border-journeyborder rounded-[12px]  px-4 py-[12px] text-16 md:text-18  md:mb-0`}
                                    />  {errors.email && <p className="text-red-500 mt-2">*{errors.email}</p>}
                                </div>
                                <div> <input
                                    type="text"
                                    onChange={(e) => handleChange(e)}
                                    value={formData.phone}
                                    name="phone"
                                    placeholder="Phone number*"
                                    required // Conditionally add the required attribute
                                    className={`w-full outline-none placeholder:text-secondaryblack border border-journeyborder rounded-[12px]  px-4 py-[12px] text-16 md:text-18  md:mb-0`}
                                />
                                    {errors.phone && <p className="text-red-500 mt-2">*{errors.phone}</p>}
                                </div>
                                {data.form.map((item, i) => (
                                    <div
                                        key={i}
                                        ref={setDivRef}
                                    >
                                        <div className="relative cursor-pointer">
                                            {/* Dropdown Button */}
                                            <div
                                                className="schemadropdown bg-white border-[1px] border-journeyborder rounded-[12px]  px-4 py-3 w-full text-left flex justify-between items-center text-dimtext"
                                                onClick={() => {
                                                    toggleDropdown(i);
                                                }}
                                            >
                                                <p className={`w-full overflow-hidden text-secondaryblack text-16 md:text-18 `}>
                                                    {formData[item.name] == "" ? item.place : formData[item.name]}
                                                </p>
                                                <span className="ml-2">
                                                    {!dropdownOpen[i] ? (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="h-4 w-4"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="h-4 w-4"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                                                clipRule="evenodd"
                                                            />
                                                        </svg>
                                                    )}
                                                </span>
                                            </div>
                                            {errors[item.name] && <p className="text-red-500 mt-2">*{errors[item.name]}</p>}

                                            {/* Dropdown Menu */}
                                            {dropdownOpen[i] && (
                                                <ul
                                                    // ref={schemaref}
                                                    className="absolute z-[148] bg-white border-[1px] border-journyborder rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto"
                                                >
                                                    {(item.name === "position" && matched?.[0]?.url === path ? datas.list : item.list).map((option, index) => (
                                                        <li
                                                            data-name={item?.name}
                                                            key={index}
                                                            className={`px-4 py-3 hover:bg-grey cursor-pointer ${formData[item.name] == option ? "bg-grey" : ""}`}
                                                            onClick={(e) => handleSelectChange(e)}
                                                        >

                                                            {option}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>))}
                            </div>

                        </div>
                        <div className="text-12 md:text-18 text-secondaryblack flex flex-col mt-6  sm:mt-8 justify-between">
                            <p className="text-18 font-semibold text-primarycolor pb-4">Upload Your Resume*</p>
                            <button
                                onClick={(e) => handleClick(e)}
                                className="text-18 flex border-[1px] rounded-[12px]  text-secondaryblack border-journyborder px-[14px] py-[10px] w-full justify-center"
                            >
                                Browse
                            </button>
                            <input
                                type="file"
                                name="file"
                                placeholder="Enter Project Name"
                                ref={fileInputRef}
                                style={{ display: "none" }} // hide the file input
                                onChange={(e) => handleFiles(e.target.files)}

                                onClick={(e) => (e.target.value = null)}
                                accept={".pdf"}
                            />
                            {errors.file && <p className="text-red-500 mt-2">*{errors.file}</p>}
                            {formData.file && <div className="flex w-full justify-between  border border-ctaorange rounded-[12px] border border-journyborder rounded-[12px]  p-2 mt-2"><p className="text-14 text-secondaryblack">{formData.file.name}</p><button
                                onClick={() => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        file: ""
                                    }));
                                }}
                            >
                                <img
                                width={20} height={20}
                                    src={process.env.PUBLIC_URL + "/images/cross.png"}
                                    alt="close"
                                />
                            </button></div>}
                        </div>
                        <div className="flex w-full justify-end gap-3 mt-6 lg:mt-10">
                            <button onClick={handleCancel} className="max-sm:hidden text-18 font-medium text-secondaryblack hover:bg-gray border border-journyborder rounded-[12px]  px-6  py-2 md:py-[10px] ">Cancel</button>
                            <button type="submit" className="text-18 font-semibold text-white max-sm:w-full bg-ctaorange hover:bg-btnhover rounded-[12px]  max-sm:py-[10px] px-6 py-2 md:py-[10px] ">Submit Application</button>

                        </div>

                    </form>
                </div>
                <div className="w-full lg:w-[40%] lg:flex max-lg:text-center">
                    <h1 className=" text-24 sm:text-28 lg:text-32 text-primarycolor font-semibold lg:pt-20">Always in search of  enthusiastic people to enrich our team</h1>
                </div>
            </div>
        </div>

    )
}
export default CareerDetail;